
<!--Header and subtitle-->
<div class="fdx-o-grid__row fdx-o-grid__row--center">
  <div class="fdx-o-grid__item--12@small-only fdx-u-align--center">
    <ng-container [ngSwitch]="method">
      <h2 class="fdx-c-header fdx-c-header--h4 fdx-u-mb--3" id="title">
        <ng-container *ngSwitchCase="'SMS'">
          <span>
            {{ 'enterPinPopup.smsTitle' | translate }}
          </span>
        </ng-container>
        <ng-container *ngSwitchCase="'EMAIL'">
          <span>
            {{ 'enterPinPopup.emailTitle' | translate }}
          </span>
        </ng-container>
        <ng-container *ngSwitchCase="'CALL'">
          <span>
            {{ 'enterPinPopup.phoneTitle' | translate }}
          </span>
        </ng-container>
      </h2>
      <h3 class="fdx-u-font-size--h7 fdx-u-text--light fdx-u-mb--7 fdx-u-ml--2 fdx-u-mr--2 " aria-live="assertive"
          aria-atomic="true" [id]="'verifySubtitle-' + method">
        <ng-container *ngSwitchCase="'SMS'">
          <span [id]="method + 'SubtitleOne'">{{ 'enterPinPopup.smsSubTitle' | translate }}</span>
          <span *ngIf="value">
            ({{value | maskValue}})
          </span>. <br>
        </ng-container>
        <ng-container *ngSwitchCase="'EMAIL'" >
          <span [id]="method + 'SubtitleOne'">{{ 'enterPinPopup.emailSubTitle' | translate }}</span>
          <span *ngIf="value">
            ({{value | maskValue}})
          </span>. <br>
        </ng-container>
        <ng-container *ngSwitchCase="'CALL'" >
          <span [id]="method + 'SubtitleOne'">{{ 'enterPinPopup.phoneSubTitle' | translate }}</span>
          <span *ngIf="value">
            ({{value | maskValue}})
          </span>. <br>
        </ng-container>
        <span id="SubtitleTwo">{{ 'enterPinPopup.codeValidity' | translate }}</span>
      </h3>
    </ng-container>
    
  <!--Adding the Form input fields containing the 6 digit verification code -->
    <div class="fdx-o-grid fdx-o-grid--max-width">
      <div class="fdx-o-grid__row fdx-o-grid__row--center">
        <div class="fdx-o-grid__item--6 fdx-u-align--left">
          <div class="fdx-u-display--flex fdx-u-flex-justify-content--center fdx-u-pb--4">
            <form [formGroup]="verificationCodeForm">
              <div class="fdx-c-single-digits">
                <fieldset class="fdx-c-single-digits__fieldset">
                  <legend class="fdx-c-single-digits__legend">{{ 'enterPinPopup.enterCode' | translate }}</legend>
                  <div class="fdx-c-single-digits__item" *ngFor="let digit of digits; let i = index;">
                    <input type="number" autocomplete="one-time-code" min="0" id="input{{i+1}}" attr.aria-label="Verification Code Digit {{i+1}}"
                      formControlName="{{digit}}" class="fdx-c-single-digits__item__input paddingWCiOS" maxlength="1" size="1" contenteditable="true"
                      name="auth-token"  inputmode="numeric" pattern="[0-9]*"
                      (keypress)="onKeyPress($event)"
                      (keyup)="onValueChange($event, i)"
                      (click)="onClickEvent(i)"
                      (blur)="onBlurEvent(i)"
                      (keydown)="onKeyDown($event, i)"
                      (paste)="pasteValues($event)"
                      (input)="handleChange()">
                  </div>
                </fieldset>
              </div>
              <div *ngIf="verificationCodeForm.invalid" class="fdx-c-form-message--error fdx-u-font-size--super-small fdx-u-mb--1"
                id="verificationFormInvalid">
                <div *ngIf="!expiredAndIncorrectError && toggleElement && (digitValidStatus
                  ||((verificationCodeForm.controls['digit1'].invalid && ( verificationCodeForm.controls['digit1'].dirty || verificationCodeForm.controls['digit1'].touched )) || (verificationCodeForm.controls['digit1'].invalid && formSubmit))
                  || ((verificationCodeForm.controls['digit2'].invalid && ( verificationCodeForm.controls['digit2'].dirty || verificationCodeForm.controls['digit2'].touched )) || (verificationCodeForm.controls['digit2'].invalid && formSubmit))
                  || ((verificationCodeForm.controls['digit3'].invalid && ( verificationCodeForm.controls['digit3'].dirty || verificationCodeForm.controls['digit3'].touched )) || (verificationCodeForm.controls['digit3'].invalid && formSubmit))
                  || ((verificationCodeForm.controls['digit4'].invalid && ( verificationCodeForm.controls['digit4'].dirty || verificationCodeForm.controls['digit4'].touched )) || (verificationCodeForm.controls['digit4'].invalid && formSubmit))
                  || ((verificationCodeForm.controls['digit5'].invalid && ( verificationCodeForm.controls['digit5'].dirty || verificationCodeForm.controls['digit5'].touched )) || (verificationCodeForm.controls['digit5'].invalid && formSubmit))
                  || ((verificationCodeForm.controls['digit6'].invalid && ( verificationCodeForm.controls['digit6'].dirty || verificationCodeForm.controls['digit6'].touched )) || (verificationCodeForm.controls['digit6'].invalid && formSubmit)))"
                      class="fdx-c-form-message fdx-c-form-message--error fdx-u-pl--0 fdx-u-pt--1"
                      role="alert">
                    <div class="fdx-u-mr--0">
                      <div style="mask-position: center">
                        <ciam-icon [color]="'red'" [key]="'utility_cross-fat'"></ciam-icon>
                      </div>
                    </div>
                    {{ 'enterPinPopup.codeRequiredError' | translate }}
                  </div>
              </div>
              <div *ngIf="expiredAndIncorrectError"
              class="fdx-c-form-message fdx-u-flex-align-items--start fdx-c-form-message--error fdx-u-mb--2 fdx-u-pl--0 fdx-u-pt--0 fdx-o-grid__item--11@large fdx-u-align--left"
              role="alert">
                <div class="fdx-u-mr--0 fdx-u-mb--3">
                  <div style="mask-position: center">
                    <ciam-icon [color]="'red'" [key]="'utility_cross-fat'"></ciam-icon>
                  </div>
                </div>
                {{ 'enterPinPopup.codeExpired' | translate }}
              </div>
              <div *ngIf="systemUnavailableError"
                    class="fdx-c-form-message fdx-u-flex-align-items--start fdx-c-form-message--error fdx-u-mb--2 fdx-u-pl--0 fdx-u-pt--0 fdx-o-grid__item--11@large fdx-u-align--left"
                    role="alert">
                <div class="fdx-u-mr--0 fdx-u-mb--3">
                  <div style="mask-position: center">
                    <ciam-icon [color]="'red'" [key]="'utility_cross-fat'"></ciam-icon>
                  </div>
                </div>
                {{ 'enterPinPopup.apiError' | translate }}
              </div>                  
            </form>
          </div>
        </div>
      </div>
    </div>
  
  <!-- submit button -->
    <div class="fdx-o-grid__item fdx-o-grid__item--12 fdx-u-align--center fdx-u-mb--3 fdx-u-mt--7">
      <button id="submit-btn" #submitBtn (click)="validatePin()"
      class="fdx-c-button fdx-c-button--full-width fdx-c-button--primary fdx-c-button--responsive"
      aria-atomic="true" aria-live="assertive">
      {{ 'common.submit' | translate }}
      </button>
    </div>

  <!-- Use a different verification method button -->
    <div class="fdx-u-align--center fdx-u-mb--5" *ngIf="useDiffMethodLink">
      <button id="verifyOptionsLink-btn" (click)="changeChannel.next({}); changeChannel.complete()"
              class="fdx-c-button fdx-c-button--suffix fdx-c-button--text fdx-c-button--responsive fdx-u-align--center" aria-atomic="true"
              aria-live="assertive">{{ 'enterPinPopup.differentVerificationMethod' | translate }}</button>
    </div>
  
  <!-- add hr line here-->
    <div class="fdx-o-grid__row fdx-o-grid__row--center">
      <hr aria-atomic="true" aria-live="assertive" role="presentation" class="fdx-c-line  fdx-c-line--grey--dark-3 fdx-o-grid__item--11">
    </div>

  <!-- Didnt receive code? -->
    <p class="fdx-u-font-size--h4 fdx-u-text--light fdx-u-mb--0 fdx-u-ml--2 fdx-u-mr--2 " aria-atomic="true"
      aria-live="assertive" id="didntReceiveCode">
      {{ 'enterPinPopup.didntReceiveCode' | translate }} 
    </p>

  <!-- subtitle -->
    <p class="fdx-c-form-group__message fdx-u-text--light fdx-u-mb--0 fdx-u-mt--0 fdx-u-ml--2 fdx-u-mr--2 fdx-u-display--block" aria-atomic="true"
      aria-live="assertive" id="didntReceiveCodeSubtitle">
      {{ 'enterPinPopup.didntReceiveCodeSubtitle' | translate }} 
    </p>

  <!-- Request New code button -->
    <div class="fdx-u-align--center fdx-u-mb--4">
      <a tabindex="0" id="requestCode-btn" (click)="resendPin()"
        class="fdx-c-button fdx-c-button--suffix fdx-c-button--text fdx-c-button--responsive" aria-atomic="true"
        aria-live="assertive">{{ 'enterPinPopup.requestNewCode' | translate }}</a>
    </div>
  </div>
    <!-- Customer Support link -->
  <div class="fdx-u-align--center">
    <p class="fdx-u-font-size--h4 fdx-u-text--light fdx-u-mb--0">
      {{ 'enterPinPopup.needHelp' | translate }}
    </p>
    <button (click)="navigateToCustomerSupport()" attr.aria-label="{{'customerSupport.supportLink' | translate }}"
            class="fdx-c-button fdx-c-button--text fdx-u-mb--7 fdx-u-cursor--pointer"
            id="support-link"
            tabindex="0">
      {{ 'enterPinPopup.supportLink'| translate }}
    </button>
  </div>
</div>
